import { createAction } from '@reduxjs/toolkit';

export const SET_CONTENTFUL = 'SET_CONTENTFUL';
export const setContentful = createAction<any>(SET_CONTENTFUL);

export const UPDATE_CONTENTFUL = 'UPDATE_CONTENTFUL';
export const updateContentful = createAction<any>(UPDATE_CONTENTFUL);
